export default __webpack_public_path__ + "img/op-sand-auger.92d7c48c.png";